import axios from 'axios';
// import sessionService from 'services/session'
import {SessionService} from 'services/SessionService'

let session = new SessionService();

let restApi = axios.create({
    // baseURL: 'http://46.101.175.68:3000/',
    // baseURL: 'http://localhost:3000/',
    // baseURL: 'http://192.168.0.23:3000/',
    // baseURL: 'https://dev.efitness.app/rest/',
    // baseURL: 'https://9e15-109-93-249-107.eu.ngrok.io/',
    baseURL: 'https://www.dostava321.in.rs/rest/',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
});

restApi.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

restApi.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        if ((error.response.status === 401 || error.response.status === 403) && !window.location.href.includes('login')) {
            return session.handleErrorResponse(error);
        }else if((error.response.status === 401 || error.response.status === 403) && window.location.href.includes('login')){
            return session.handleLoginErrorResponse(error)
        }else {
            return Promise.reject(error.response);
        }
    }
);

// restApi.interceptors.response.use(function (response) {
//     return response;
// }, function (error) {
//     if ((error.response.status === 401 || error.response.status === 403) && !window.location.pathname.includes('login')) {
//         if (error.response.status === 401 && error.response.data.message === "Credentials are invalid!") {
//             console.log("skrba1")
//             return Promise.reject(error.response)
//         } else {
//             console.log("skrba2")
//             this.$sessionService.handleErrorResponse(error);
//             this.logout()
//             // delete axios.defaults.headers.common['authorization'];
//             // return new Promise(() => {
//             // });
//         }
//     } else {
//         console.log("skrba3")
//         return Promise.reject(error.response)
//     }
// });

export default restApi



// WEBPACK FOOTER //
// ./src/http-common.js